export * from './agentPairingOperator.service';
import { AgentPairingOperatorService } from './agentPairingOperator.service';
export * from './agentPairingVcdr.service';
import { AgentPairingVcdrService } from './agentPairingVcdr.service';
export * from './appInfoOperator.service';
import { AppInfoOperatorService } from './appInfoOperator.service';
export * from './auditLogOperator.service';
import { AuditLogOperatorService } from './auditLogOperator.service';
export * from './authorizationOauthAppsOperator.service';
import { AuthorizationOauthAppsOperatorService } from './authorizationOauthAppsOperator.service';
export * from './authorizationOauthAppsVcdr.service';
import { AuthorizationOauthAppsVcdrService } from './authorizationOauthAppsVcdr.service';
export * from './authorizationOauthAppsVmcfs.service';
import { AuthorizationOauthAppsVmcfsService } from './authorizationOauthAppsVmcfs.service';
export * from './awsOperator.service';
import { AwsOperatorService } from './awsOperator.service';
export * from './billingEnforcementOperator.service';
import { BillingEnforcementOperatorService } from './billingEnforcementOperator.service';
export * from './billingEnforcementVcdr.service';
import { BillingEnforcementVcdrService } from './billingEnforcementVcdr.service';
export * from './billingEnforcementVmcfs.service';
import { BillingEnforcementVmcfsService } from './billingEnforcementVmcfs.service';
export * from './billingEntityOperator.service';
import { BillingEntityOperatorService } from './billingEntityOperator.service';
export * from './billingEventOperator.service';
import { BillingEventOperatorService } from './billingEventOperator.service';
export * from './billingLogsOperator.service';
import { BillingLogsOperatorService } from './billingLogsOperator.service';
export * from './billingMaintenanceOperator.service';
import { BillingMaintenanceOperatorService } from './billingMaintenanceOperator.service';
export * from './billingMetricInfoOperator.service';
import { BillingMetricInfoOperatorService } from './billingMetricInfoOperator.service';
export * from './billingPipelineOperator.service';
import { BillingPipelineOperatorService } from './billingPipelineOperator.service';
export * from './billingProvisioningOperator.service';
import { BillingProvisioningOperatorService } from './billingProvisioningOperator.service';
export * from './billingSddcQuotaOperator.service';
import { BillingSddcQuotaOperatorService } from './billingSddcQuotaOperator.service';
export * from './billingSkuInfoOperator.service';
import { BillingSkuInfoOperatorService } from './billingSkuInfoOperator.service';
export * from './billingSubscriptionOperator.service';
import { BillingSubscriptionOperatorService } from './billingSubscriptionOperator.service';
export * from './billingUsageOperator.service';
import { BillingUsageOperatorService } from './billingUsageOperator.service';
export * from './cloudCostMgmtOperator.service';
import { CloudCostMgmtOperatorService } from './cloudCostMgmtOperator.service';
export * from './cloudProviderOperator.service';
import { CloudProviderOperatorService } from './cloudProviderOperator.service';
export * from './cloudProviderVcdr.service';
import { CloudProviderVcdrService } from './cloudProviderVcdr.service';
export * from './cloudProviderVmcfs.service';
import { CloudProviderVmcfsService } from './cloudProviderVmcfs.service';
export * from './commerceVcdr.service';
import { CommerceVcdrService } from './commerceVcdr.service';
export * from './commerceVmcfs.service';
import { CommerceVmcfsService } from './commerceVmcfs.service';
export * from './componentConfigsOperator.service';
import { ComponentConfigsOperatorService } from './componentConfigsOperator.service';
export * from './configsOperator.service';
import { ConfigsOperatorService } from './configsOperator.service';
export * from './cspProxyOperator.service';
import { CspProxyOperatorService } from './cspProxyOperator.service';
export * from './deploymentOperator.service';
import { DeploymentOperatorService } from './deploymentOperator.service';
export * from './deploymentVcdr.service';
import { DeploymentVcdrService } from './deploymentVcdr.service';
export * from './deploymentVmcfs.service';
import { DeploymentVmcfsService } from './deploymentVmcfs.service';
export * from './eventsOperator.service';
import { EventsOperatorService } from './eventsOperator.service';
export * from './eventsVcdr.service';
import { EventsVcdrService } from './eventsVcdr.service';
export * from './eventsVmcfs.service';
import { EventsVmcfsService } from './eventsVmcfs.service';
export * from './fleetOrchestrationOperator.service';
import { FleetOrchestrationOperatorService } from './fleetOrchestrationOperator.service';
export * from './fleetOrchestrationVcdr.service';
import { FleetOrchestrationVcdrService } from './fleetOrchestrationVcdr.service';
export * from './fleetOrchestrationVmcfs.service';
import { FleetOrchestrationVmcfsService } from './fleetOrchestrationVmcfs.service';
export * from './gcpOperator.service';
import { GcpOperatorService } from './gcpOperator.service';
export * from './inventoryDisconnectedOperator.service';
import { InventoryDisconnectedOperatorService } from './inventoryDisconnectedOperator.service';
export * from './inventoryDisconnectedVcdr.service';
import { InventoryDisconnectedVcdrService } from './inventoryDisconnectedVcdr.service';
export * from './inventoryOperator.service';
import { InventoryOperatorService } from './inventoryOperator.service';
export * from './inventoryVcdr.service';
import { InventoryVcdrService } from './inventoryVcdr.service';
export * from './inventoryVmcfs.service';
import { InventoryVmcfsService } from './inventoryVmcfs.service';
export * from './irrProxyOperator.service';
import { IrrProxyOperatorService } from './irrProxyOperator.service';
export * from './locksOperator.service';
import { LocksOperatorService } from './locksOperator.service';
export * from './maintenanceOperator.service';
import { MaintenanceOperatorService } from './maintenanceOperator.service';
export * from './maintenanceVcdr.service';
import { MaintenanceVcdrService } from './maintenanceVcdr.service';
export * from './maintenanceVmcfs.service';
import { MaintenanceVmcfsService } from './maintenanceVmcfs.service';
export * from './monitoringOperator.service';
import { MonitoringOperatorService } from './monitoringOperator.service';
export * from './notificationOperator.service';
import { NotificationOperatorService } from './notificationOperator.service';
export * from './oauthAppsOperator.service';
import { OauthAppsOperatorService } from './oauthAppsOperator.service';
export * from './orchestratorOperator.service';
import { OrchestratorOperatorService } from './orchestratorOperator.service';
export * from './orchestratorVcdr.service';
import { OrchestratorVcdrService } from './orchestratorVcdr.service';
export * from './orchestratorVmcfs.service';
import { OrchestratorVmcfsService } from './orchestratorVmcfs.service';
export * from './orgCapabilitiesOperator.service';
import { OrgCapabilitiesOperatorService } from './orgCapabilitiesOperator.service';
export * from './orgMgmtOperator.service';
import { OrgMgmtOperatorService } from './orgMgmtOperator.service';
export * from './orgMgmtVcdr.service';
import { OrgMgmtVcdrService } from './orgMgmtVcdr.service';
export * from './orgMgmtVmcfs.service';
import { OrgMgmtVmcfsService } from './orgMgmtVmcfs.service';
export * from './orgTelemetryVcdr.service';
import { OrgTelemetryVcdrService } from './orgTelemetryVcdr.service';
export * from './orgTelemetryVmcfs.service';
import { OrgTelemetryVmcfsService } from './orgTelemetryVmcfs.service';
export * from './orgVmcTelemetryVcdr.service';
import { OrgVmcTelemetryVcdrService } from './orgVmcTelemetryVcdr.service';
export * from './pooledOrgOperator.service';
import { PooledOrgOperatorService } from './pooledOrgOperator.service';
export * from './providerOperatorAgent.service';
import { ProviderOperatorAgentService } from './providerOperatorAgent.service';
export * from './providerVcdrAgent.service';
import { ProviderVcdrAgentService } from './providerVcdrAgent.service';
export * from './providerVmcfsAgent.service';
import { ProviderVmcfsAgentService } from './providerVmcfsAgent.service';
export * from './provisioningNotificationErp.service';
import { ProvisioningNotificationErpService } from './provisioningNotificationErp.service';
export * from './quartzScheduledJobsOperator.service';
import { QuartzScheduledJobsOperatorService } from './quartzScheduledJobsOperator.service';
export * from './ransomwareRecoveryOperator.service';
import { RansomwareRecoveryOperatorService } from './ransomwareRecoveryOperator.service';
export * from './ransomwareRecoveryOperatorV2.service';
import { RansomwareRecoveryOperatorV2Service } from './ransomwareRecoveryOperatorV2.service';
export * from './ransomwareRecoveryVcdrV2.service';
import { RansomwareRecoveryVcdrV2Service } from './ransomwareRecoveryVcdrV2.service';
export * from './releaseOperator.service';
import { ReleaseOperatorService } from './releaseOperator.service';
export * from './resourceOperator.service';
import { ResourceOperatorService } from './resourceOperator.service';
export * from './resourceProviderPoolOperator.service';
import { ResourceProviderPoolOperatorService } from './resourceProviderPoolOperator.service';
export * from './resourceProviderPoolVcdr.service';
import { ResourceProviderPoolVcdrService } from './resourceProviderPoolVcdr.service';
export * from './resourceVcdr.service';
import { ResourceVcdrService } from './resourceVcdr.service';
export * from './scheduledJobsOperator.service';
import { ScheduledJobsOperatorService } from './scheduledJobsOperator.service';
export * from './sddcOperator.service';
import { SddcOperatorService } from './sddcOperator.service';
export * from './tasksOperator.service';
import { TasksOperatorService } from './tasksOperator.service';
export * from './tasksVcdr.service';
import { TasksVcdrService } from './tasksVcdr.service';
export * from './tasksVmcfs.service';
import { TasksVmcfsService } from './tasksVmcfs.service';
export * from './unifiedSecretsOperator.service';
import { UnifiedSecretsOperatorService } from './unifiedSecretsOperator.service';
export * from './upgradeOperator.service';
import { UpgradeOperatorService } from './upgradeOperator.service';
export * from './uptimeOperator.service';
import { UptimeOperatorService } from './uptimeOperator.service';
export * from './uptimeVcdr.service';
import { UptimeVcdrService } from './uptimeVcdr.service';
export * from './usageConfigOperator.service';
import { UsageConfigOperatorService } from './usageConfigOperator.service';
export * from './userProfileOperator.service';
import { UserProfileOperatorService } from './userProfileOperator.service';
export * from './vmcOperator.service';
import { VmcOperatorService } from './vmcOperator.service';
export * from './vmcUsageOperator.service';
import { VmcUsageOperatorService } from './vmcUsageOperator.service';
export const APIS = [AgentPairingOperatorService, AgentPairingVcdrService, AppInfoOperatorService, AuditLogOperatorService, AuthorizationOauthAppsOperatorService, AuthorizationOauthAppsVcdrService, AuthorizationOauthAppsVmcfsService, AwsOperatorService, BillingEnforcementOperatorService, BillingEnforcementVcdrService, BillingEnforcementVmcfsService, BillingEntityOperatorService, BillingEventOperatorService, BillingLogsOperatorService, BillingMaintenanceOperatorService, BillingMetricInfoOperatorService, BillingPipelineOperatorService, BillingProvisioningOperatorService, BillingSddcQuotaOperatorService, BillingSkuInfoOperatorService, BillingSubscriptionOperatorService, BillingUsageOperatorService, CloudCostMgmtOperatorService, CloudProviderOperatorService, CloudProviderVcdrService, CloudProviderVmcfsService, CommerceVcdrService, CommerceVmcfsService, ComponentConfigsOperatorService, ConfigsOperatorService, CspProxyOperatorService, DeploymentOperatorService, DeploymentVcdrService, DeploymentVmcfsService, EventsOperatorService, EventsVcdrService, EventsVmcfsService, FleetOrchestrationOperatorService, FleetOrchestrationVcdrService, FleetOrchestrationVmcfsService, GcpOperatorService, InventoryDisconnectedOperatorService, InventoryDisconnectedVcdrService, InventoryOperatorService, InventoryVcdrService, InventoryVmcfsService, IrrProxyOperatorService, LocksOperatorService, MaintenanceOperatorService, MaintenanceVcdrService, MaintenanceVmcfsService, MonitoringOperatorService, NotificationOperatorService, OauthAppsOperatorService, OrchestratorOperatorService, OrchestratorVcdrService, OrchestratorVmcfsService, OrgCapabilitiesOperatorService, OrgMgmtOperatorService, OrgMgmtVcdrService, OrgMgmtVmcfsService, OrgTelemetryVcdrService, OrgTelemetryVmcfsService, OrgVmcTelemetryVcdrService, PooledOrgOperatorService, ProviderOperatorAgentService, ProviderVcdrAgentService, ProviderVmcfsAgentService, ProvisioningNotificationErpService, QuartzScheduledJobsOperatorService, RansomwareRecoveryOperatorService, RansomwareRecoveryOperatorV2Service, RansomwareRecoveryVcdrV2Service, ReleaseOperatorService, ResourceOperatorService, ResourceProviderPoolOperatorService, ResourceProviderPoolVcdrService, ResourceVcdrService, ScheduledJobsOperatorService, SddcOperatorService, TasksOperatorService, TasksVcdrService, TasksVmcfsService, UnifiedSecretsOperatorService, UpgradeOperatorService, UptimeOperatorService, UptimeVcdrService, UsageConfigOperatorService, UserProfileOperatorService, VmcOperatorService, VmcUsageOperatorService];
